import React, { useMemo } from "react";
import OptionSelector from "../shared/OptionSelector";
import MeasurementInput from "../shared/MeasurementInput";
import WindowDiagram from "../diagrams/WindowDiagram";
import { validateDimension } from "../utils/measurementValidation";
import {
  FIELD_WIDTH,
  FIELD_HEIGHT,
  FIELD_WINDOW_PRODUCT_SIZE_ID,
} from "../constants/fieldNames";

const SizesTab = ({ formData, onChange, availableOptions, windowProduct }) => {
  const isCustomSizeSelected = () => {
    const selectedSize = availableOptions.window_product_sizes.find(
      (size) => size.id === formData.window_product_size_id
    );
    return selectedSize && selectedSize.name.toLowerCase() === "custom";
  };

  const isCustom = isCustomSizeSelected();

  // Get applicable constraints based on internal blind selection
  const applicableConstraints = useMemo(() => {
    if (
      !isCustom ||
      !availableOptions?.size_constraints?.length
    ) {
      return [];
    }
    const hasInternalBlind = !!formData.internal_blind_id;
    return availableOptions.size_constraints.filter(
      (constraint) => constraint.requires_internal_blind === hasInternalBlind
    );
  }, [
    formData.window_product_size_id,
    formData.internal_blind_id,
    availableOptions?.size_constraints,
  ]);


  return (
    <div className="flex flex-col items-center py-4">
      <div className="relative">
        <WindowDiagram windowTypeName={windowProduct.name} mode="display" />

        <div className="flex justify-center md:block md:absolute md:right-full md:mr-4 md:top-1/2 md:transform md:-translate-y-1/2 md:whitespace-nowrap mt-4 md:mt-0">
          <OptionSelector
            name={FIELD_WINDOW_PRODUCT_SIZE_ID}
            options={availableOptions.window_product_sizes}
            value={formData.window_product_size_id}
            onChange={(value) => onChange(FIELD_WINDOW_PRODUCT_SIZE_ID, value)}
            includeNone={false}
            required
            radio={true}
            optionTestIdPrefix="window-size"
          />
        </div>
        <div
          className="flex justify-center md:block md:absolute md:left-full md:ml-4 md:top-1/2 md:transform md:-translate-y-1/2 mt-4 md:mt-0"
          style={{ display: isCustom ? "block" : "none" }}
        >
          <MeasurementInput
            name={FIELD_HEIGHT}
            placeholder="H"
            value={formData.height}
            onChange={(value) => onChange(FIELD_HEIGHT, value)}
            required={isCustom}
            errorMessage={
              isCustom ? validateDimension(applicableConstraints, formData, FIELD_HEIGHT) : null
            }
          />
        </div>
      </div>

      <div className="mt-4" style={{ display: isCustom ? "block" : "none" }}>
        <MeasurementInput
          name={FIELD_WIDTH}
          placeholder="W"
          value={formData.width}
          onChange={(value) => onChange(FIELD_WIDTH, value)}
          required={isCustom}
          errorMessage={
            isCustom ? validateDimension(applicableConstraints, formData, FIELD_WIDTH) : null
          }
        />
      </div>
    </div>
  );
};

export default SizesTab;
